import React, { useState, useEffect } from "react";
import axios from "axios";
import { tsExternalModuleReference } from "@babel/types";
import UPSLabel from '../../Images/LOGO_L.gif'

import "./PaymentForm.css";

function PaymentForm(props) {
  const styles = {
    name: {
      verticalAlign: "top",
      display: "block",
      margin: 0,
      border: "none",
      fontSize: "16px",
      fontFamily: "Helvetica Neue",
      padding: "16px",
      color: "#373F4A",
      backgroundColor: "transparent",
      lineHeight: "1.15em",
      placeholderColor: "#000",
      _webkitFontSmoothing: "antialiased",
      _mozOsxFontSmoothing: "grayscale"
    },
    leftCenter: {
      float: "left",
      textAlign: "center"
    },
    blockRight: {
      display: "block",
      float: "right"
    },
    center: {
      textAlign: "center"
    }
  };

  const [cardBrand, setCardBrand] = useState("");
  const [nonce, setNonce] = useState(undefined);
  const [paymentForm, setPaymentForm] = useState(undefined);
  const [url, setUrl] = useState(window.location.href);
  const [quantity, setQuantity] = useState(1);
  const [taxPercent, setTaxPercent] = useState(0);
  const [shippingPrice, setShippingPrice] = useState(7);
  const [priceTotal, setPriceTotal] = useState(0);

  const [projectId, setProjectId] = useState(0);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [comments, setComments] = useState("");
  const [paid, setPaid] = useState(false)

  const [addressValidated, setAddressValidated] = useState(false);

  const [enhancementFee, setEnhancementFee] = useState(0)

  //calculate total
  const getTotal = () => {
    var TempPrice = props.Product.Price * quantity
    

    var TempShippingPrice = 7;
    if (TempPrice >= 35){
      TempShippingPrice = 0;
      setShippingPrice(0);
    }
    else{
      setShippingPrice(7);
    }

    var TempTotal = props.Product.Price * quantity +
                    props.Product.Price * quantity * taxPercent +
                    shippingPrice + enhancementFee;

    

    setPriceTotal(
      (
        TempTotal
      ).toFixed(2)
    );
  };

  const selectState = value => {
    if (value == "CA") {
      if (city.toLowerCase() == 'norco'){
        setTaxPercent(0.0825);
      }
      else {
        setTaxPercent(0.0725);
      }
      
    } else {
      setTaxPercent(0);
    }
  };

  
  const selectCity = value => {
    if (value.toLowerCase() == 'norco' && state == 'CA'){
      setTaxPercent(0.0825)
    }
  }


  const checkTax = () => {
    if (state == "CA") {
      if (city.toLowerCase() == 'norco'){
        setTaxPercent(0.0825);
      }
      else {
        setTaxPercent(0.0725);
      }
      
    } else {
      setTaxPercent(0);
    }
  }

  useEffect(() => {
    checkTax();
    getTotal();
  }, [quantity, priceTotal, taxPercent, city, state, addressValidated]);

  //LOADED USEEFFECT
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    let sqpPaymentScript = document.createElement("script");
    sqpPaymentScript.src = "https://js.squareup.com/v2/paymentform";
    sqpPaymentScript.type = "text/javascript";
    sqpPaymentScript.async = false;
    sqpPaymentScript.onload = () => {
      setLoaded(true);
    };
    document.head.appendChild(sqpPaymentScript);
  }, []);

  useEffect(() => {
    const pay = () => {
      const config = {
        applicationId: "sq0idp-EY54hhJ0lvtEfcz8L-4D6Q",
        locationId: "304WXDW729PSC",
        inputClass: "sq-input",
        autoBuild: false,
        inputStyles: [
          {
            fontSize: "16px",
            fontFamily: "Helvetica Neue",
            padding: "16px",
            color: "#373F4A",
            backgroundColor: "transparent",
            lineHeight: "1.15em",
            placeholderColor: "#000",
            _webkitFontSmoothing: "antialiased",
            _mozOsxFontSmoothing: "grayscale"
          }
        ],
        applePay: {
          elementId: "sq-apple-pay"
        },
        masterpass: {
          elementId: "sq-masterpass"
        },
        googlePay: {
          elementId: "sq-google-pay"
        },
        cardNumber: {
          elementId: "sq-card-number",
          placeholder: "• • • •  • • • •  • • • •  • • • •"
        },
        cvv: {
          elementId: "sq-cvv",
          placeholder: "CVV"
        },
        expirationDate: {
          elementId: "sq-expiration-date",
          placeholder: "MM/YY"
        },
        postalCode: {
          elementId: "sq-postal-code",
          placeholder: "Zip"
        },
        callbacks: {
          methodsSupported: methods => {
            if (methods.googlePay) {
              /*
            this.setState({
              googlePay: methods.googlePay
            });
            */
            }
            if (methods.applePay) {
              /*
            this.setState({
              applePay: methods.applePay
            });
            */
            }
            if (methods.masterpass) {
              /*
            this.setState({
              masterpass: methods.masterpass
            });
            */
            }
            return;
          },
          createPaymentRequest: () => {
            return {
              requestShippingAddress: false,
              requestBillingInfo: true,
              currencyCode: "USD",
              countryCode: "US",
              total: {
                label: "Caigoy Creations",
                //amount: {priceTotal},
                amount: { quantity },
                pending: false
              }
              /*
            lineItems: [
              {
                label: "Subtotal",
                amount: "1",
                pending: false
              }
            ]
            */
            };
          },
          cardNonceResponseReceived: (errors, nonce, cardData) => {
            if (errors) {
              // Log errors from nonce generation to the Javascript console
              console.log("Encountered errors:");
              errors.forEach(function(error) {
                console.log("  " + error.message);
                setPaid(false)
              });

              return;
            } /*
          this.setState({
            nonce: nonce
          });
          */
            setNonce(nonce);
            console.log(nonce);
            submitOrder(nonce);
            //alert(nonce);
            //testNonce(nonce);
          },
          unsupportedBrowserDetected: () => {},
          inputEventReceived: inputEvent => {
            switch (inputEvent.eventType) {
              case "focusClassAdded":
                break;
              case "focusClassRemoved":
                break;
              case "errorClassAdded":
                //document.getElementById("error").innerHTML =
                console.log(inputEvent);
                alert(
                  "Please fix card information errors before continuing:  " +
                    inputEvent.field
                );
                break;
              case "errorClassRemoved":
                //document.getElementById("error").style.display = "none";
                break;
              case "cardBrandChanged":
                if (inputEvent.cardBrand !== "unknown") {
                  /*
                this.setState({
                  cardBrand: inputEvent.cardBrand
                });
                */
                  setCardBrand(inputEvent.cardBrand);
                } else {
                  /*
                this.setState({
                  cardBrand: ""
                });
                */
                  setCardBrand(inputEvent.cardBrand);
                }
                break;
              case "postalCodeChanged":
                break;
              default:
                break;
            }
          },
          paymentFormLoaded: function() {
            document.getElementById("name").style.display = "inline-flex";
          }
        }
      };
      let tempPaymentForm = new props.paymentForm(config);
      setPaymentForm(tempPaymentForm);

      tempPaymentForm.build();
    };

    pay();
  }, [quantity, firstName, lastName, email, addressLine1, addressLine2, city, state, zip, comments, addressValidated]);
  //end useEffect
  
  const validateAddress = () => {
    
    axios({
      //url: "http://localhost:44316/orders/validateaddress",
      url: 'https://api.caigoycreations.com/orders/validateaddress',
      params: {
        Address: addressLine1 + " " + addressLine2,
        City: city,
        State: state,
        Zip: zip
      }
    }).then(
      res => {
        if (res.data.data){
          axios({
            url: 'https://api.caigoycreations.com/orders/correctaddress',
            params: {
              Address: addressLine1 + " " + addressLine2,
              City: city,
              State: state,
              Zip: zip
            }
          }).then(
            res => {
              let addressObject = res.data.data;
              setAddressLine1(addressObject.Address);
              setCity(addressObject.City);
              setZip(addressObject.Zip);
              setState(addressObject.State)
              setAddressValidated(true);
            },
            err => {
              console.log(err);
              alert(err);
            });
        }
        else {
          alert('invalid address')
        }
      },
      err => {
        console.log(err);
        alert(err)
      });
      
  }


  const requestCardNonce = Values => {
    //event.preventDefault();
    //console.log(event)
    //alert('inside request card nonce')
    paymentForm.requestCardNonce();
    
  }

  const pv = event => {
    event.preventDefault();
  }

  //submit button
  const submitOrder = nonceValue => {
    //prevent default to not actually submit
    //event.preventDefault();
    //requestCardNonce();
    //alert('submit order')
    //validate address
    setPaid(true)
    let Params = {
      Address: addressLine1 + " " + addressLine2,
      City: city,
      State: state,
      Zip: zip
    }
    if(nonceValue){
      console.log(Params)
    //alert(Params)
    axios({
      //url: "http://localhost:44316/orders/validateaddress",
      url: 'https://api.caigoycreations.com/orders/validateaddress',
      params: {
        Address: addressLine1 + " " + addressLine2,
        City: city,
        State: state,
        Zip: zip
      }
    }).then(
      res => {
        console.log(res);
        if (res.data.data) {
          //send amount to square and get nonce
          //requestCardNonce();

          var Values = {
            Id: 0,
            ProjectId: props.Id,
            Quantity: quantity,
            SubTotal: props.Product.Price * quantity,
            ShippingPrice: shippingPrice,
            Tax: (props.Product.Price * quantity * taxPercent).toFixed(2),
            Total: priceTotal,
            FirstName: firstName,
            LastName: lastName,
            Phone: null,
            Email: email,
            AddressLine1: addressLine1,
            AddressLine2: addressLine2,
            City: city,
            State: state,
            Zip: zip,
            AdditionalComments: comments,
            GUID: null,
            Nonce: nonceValue,
            PaymentId: null,
            IsEnhanceRequestd: document.getElementById('EnhanceYes').checked
          };
          //create order with needed values
          axios({
            url:
              //"http://localhost:44316/orders/createorder?Values=" +
              'https://api.caigoycreations.com/orders/createorder?Values=' +
              JSON.stringify(Values),
            method: "post"
          }).then(
            res => {
              console.log(res.data.data)
              let tempOrder = res.data.data;
              alert('Success')
              window.location.href = 'https://caigoycreations.com/storereceipt/'+tempOrder.GUID;
            },
            err => {
              console.log(err)
              alert(err);
            }
          );
        } else {
          alert("invalid address");
          setPaid(false)
        }
      },
      err => {
        alert("error with verifying address. error:  " + err);
        setPaid(false)
      }
    );
  }
  else {
    alert('nonce not set')
    setPaid(false)
  }
  };

  const copyText = url => {
      // Create new element
      var el = document.createElement('textarea');
      // Set value (string to be copied)
      el.value = url;
      // Set non-editable to avoid focus and move outside of view
      el.setAttribute('readonly', '');
      el.style = {position: 'absolute', left: '-9999px'};
      document.body.appendChild(el);
      // Select text inside element
      el.select();
      // Copy text to clipboard
      document.execCommand('copy');
      // Remove temporary element
      document.body.removeChild(el);
  }

  return (
    loaded && (
      <div className="container">
        <div className="SubmitForm">
          <form className="SubmissionForm" onSubmit={pv}>
            <br />
            <strong>Note: Please save this link to find your C creation</strong>
            <br />

            <div id='Url'
              style={{
                display: 'flex',
                flexDirection: 'column',
                overflowWrap: 'break-word'
              }}
            >
              {url}
              <br /><br />
              <input 
                type='button'
                value='Copy Url Link'
                style={{
                  display: 'flex',
                  marginRight: 0,
                  marginLeft: 'auto',
                  padding: '5px',
                  borderRadius: '15px',
                  backgroundColor: '#ccc',
                  border: '2px solid white'
                }}
                onClick={ () => {copyText(url)}}
              />
            </div>

            <br />
            <br />

            <h2>Order Information</h2>

            <div className='ViewItem'>
              <label>Item:</label>
              <label>{props.Product.Name}</label>
            </div>

            
            <div className='ViewItem'>
              <label>Price (each):</label>

              <label>${props.Product.Price}</label>
            </div>

            <div className='ViewItem'>
              <label>Quantity:</label>
              <input
                type="number"
                style={{ width: "50px" }}
                value={quantity}
                onChange={e => {
                  if (e.target.value > 0) {
                    setQuantity(e.target.value);
                    getTotal();
                  }
                }}
                required
              />
            </div>

            <br />
              
            <div className='Enhance'>
              <strong>Would you like your photo professionally enhanced?</strong>
              <br />
                <img 
                  src="https://caigoycreations.com/static/media/Enhance.jpg"
                  style={{width: '90%'}}
                />

                <div className='Question'>
                  {/* <div className='Answer'>
                    <input 
                      type='radio' 
                      name='Enhance' 
                      checked
                      onClick={() =>{
                        console.log('from no' + document.getElementById('EnhanceYes').checked);
                      }}
                    />
                    <label>No thanks</label>
                  </div> */}

                  <div className='Answer'>
                    <input 
                      type='checkbox' 
                      name='Enhance'
                      id='EnhanceYes'
                      onChange={e => {
                        if (e.target.checked){
                          setEnhancementFee(5)
                        }
                        else {
                          setEnhancementFee(0);
                        }
                        setPriceTotal();
                      }}
                    />
                    <label>Yes ($5 charge)</label>
                  </div>
                </div>
            </div>


            <br />
            <br />

            <h2>Contact Information</h2>

            <div className='ViewItem'>
              <label>First Name:</label>
              <input
                type="text"
                onChange={e => {
                  setFirstName(e.target.value);
                }}
                required
              />
            </div>

            <div className='ViewItem'>
              <label>Last Name:</label>
              <input
                type="text"
                onChange={e => {
                  setLastName(e.target.value);
                }}
                required
              />
            </div>

            <div className='ViewItem'>
              <label>Email:</label>
              <input
                type="text"
                onChange={e => {
                  setEmail(e.target.value);
                }}
                required
              />
            </div>

            <br />
            <br />

            <div className='ViewItem' style={{margin: '25px 0'}}>
              <h2>Shipping Information</h2>
              <img style={{
                width: '50px',
                height: '50px'
                }} src={UPSLabel} />

            </div>
            <div className='ViewItem'>
              <label>Address Line 1:</label>
              <input
                type="text"
                onChange={e => {
                  setAddressLine1(e.target.value);
                  setAddressValidated(false)
                }}
                required
              />
            </div>

            <div className='ViewItem'>
              <label>Address Line 2:</label>
              <input
                type="text"
                onChange={e => {
                  setAddressLine2(e.target.value);
                  setAddressValidated(false)
                }}
              />
            </div>

            <div className='ViewItem'>
              <label>City:</label>
              <input
                type="text"
                value={city}
                onChange={e => {
                  setCity(e.target.value);
                  selectCity(e.target.value);
                  setAddressValidated(false)
                }}
              />
            </div>

            <div className='ViewItem'>
              <label>State:</label>
              <select
                name="state"
                id="state"
                value={state}
                onChange={e => {
                  console.log(e.target.value);
                  selectState(e.target.value);
                  setState(e.target.value);
                  setAddressValidated(false)

                }}
              >
                <option value="" selected="selected">
                  Select a State
                </option>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District Of Columbia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </select>
            </div>

            <div className='ViewItem'>
              <label>
                Zip:
              </label>
              <input
                type="text"
                onChange={e => {
                  setZip(e.target.value);
                  setAddressValidated(false)

                }}
              />
            </div>

            <br />

            <br />
            <div>
              <h2>Additional Comments</h2>
              <br />
              <textarea
                onChange={e => {
                  setComments(e.target.value);
                }}
                style={{width: '100%', minHeight: '100px'}}
              ></textarea>
            </div>

            <br />
            <br />
            <div className="Price">
              <input style={{fontWeight: '900', color: '#990000'}} type='button' value='Click to Validate Address' onClick={() => {validateAddress()}} />              
              <br /><br />

              <div className="PriceBox">
                <div>SubTotal:</div>
                <div>${(props.Product.Price * quantity).toFixed(2)}</div>
              </div>

              <div className="PriceBox">
                <div>Tax</div>
                <div>
                  ${(props.Product.Price * quantity * taxPercent).toFixed(2)}
                </div>
              </div>

              <div className="PriceBox">
                <div>Professional Enhancement Fee</div>
                <div>
                  ${enhancementFee}
                </div>
              </div>

              <div className="PriceBox">
                <div>Shipping Price:</div>
                <div>${shippingPrice.toFixed(2)}</div>
              </div>

              <hr />
              <br />
              <div className="Total">
                <div>Total</div>
                <div>${priceTotal}</div>
              </div>

              <br />
              <br />
              <span style={{color: '#dd0000'}}>If your subtotal is $35 or more, shipping is Free!</span>

      
            </div>

            <br />

            <h2>Payment</h2>

            <div id="form-container">
              {/*
            <div id="sq-walletbox">
              <button
                //style={{ display: this.state.applePay ? "inherit" : "none" }}
                className="wallet-button"
                id="sq-apple-pay"
              ></button>
              <button
                //style={{ display: this.state.masterpass ? "block" : "none" }}
                className="wallet-button"
                id="sq-masterpass"
              ></button>
              <button
                //style={{ display: this.state.googlePay ? "inherit" : "none" }}
                className="wallet-button"
                id="sq-google-pay"
              ></button>
              <hr />
            </div>
          */}

              <div id="sq-ccbox">
                <p>
                  <span style={styles.leftCenter}>Enter Card Info Below </span>
                  <span style={styles.blockRight}>
                    {/* this.state.cardBrand.toUpperCase() */}
                  </span>
                </p>
                <div id="cc-field-wrapper">
                  <div id="sq-card-number"></div>
                  <input type="hidden" id="card-nonce" name="nonce" />
                  <div id="sq-expiration-date"></div>
                  <div id="sq-cvv"></div>
                </div>
                <input
                  id="name"
                  style={styles.name}
                  type="text"
                  placeholder="Name on card"
                />
                <div id="sq-postal-code"></div>
              </div>
              {/*
            <button 
              className="button-credit-card"
              style={{margin: '0 auto'}}
              onClick={requestCardNonce} 
              disabled={true}
            >
              Pay
            </button>
            */}
              <br />
            </div>
            <br />
            <div style={{ display: "flex" }}>
              <br />
              <input
                type="submit"
                className="button-credit-card"
                style={{ margin: "0 auto" }}
                onClick={() => {
                  requestCardNonce();
                  setPaid(true)
                }}
                disabled={paid || !addressValidated}
              />

            </div>
            <br />
            {!addressValidated && 
              <div style={{textAlign: 'center',
                          color: 'red'}}>
                Please Validate Address
              </div>
            }

          </form>
        </div>
      </div>
    )
  );
}

export default PaymentForm;
